import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AgentHubPromotion"] */ "/workspace/src/components/Home/AgentHub/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommunitiesSection"] */ "/workspace/src/components/Home/Communities/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/workspace/src/components/Home/Hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpportunityCard"] */ "/workspace/src/components/Home/Opportunities/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PocketListingSection"] */ "/workspace/src/components/Home/PocketListing/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopularSearchSection"] */ "/workspace/src/components/Home/PopularSearch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToolsSection"] */ "/workspace/src/components/Home/Tools/index.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/ui/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/workspace/src/components/ui/Separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchProvider"] */ "/workspace/src/contexts/SearchContext/index.tsx");
